import { Building2Icon, GlobeIcon, LockIcon } from 'lucide-react';

import type { SourceVisibility } from '@/api/types/sources';

export const sourceVisibilityItems = [
  {
    name: 'Private',
    value: 'private' as const,
    description: 'Only users added to the source get access.',
    longName: 'Private Visibility',
    icon: LockIcon,
  },
  {
    name: 'Internal',
    value: 'internal' as const,
    description: 'Any member of this organization gets access to the source.',
    longName: 'Internal Visibility',
    icon: Building2Icon,
  },
  {
    name: 'Public',
    value: 'public' as const,
    description: 'Anyone on the internet with the source link gets access to the source.',
    longName: 'Public Visibility',
    icon: GlobeIcon,
  },
];

export type SourceVisibilityItem = (typeof sourceVisibilityItems)[number];

export const sourceVisibilityValues = ['private', 'internal', 'public'] satisfies [
  SourceVisibility,
  ...SourceVisibility[],
];
export const sourceVisibilityFilterValues = ['all', ...sourceVisibilityValues] as const;
